export default __webpack_public_path__ + "static/media/File_shape.8d6f3b5a.svg";